import React from "react";
import {
  IonSearchbar,
  IonSelect,
  IonSelectOption,
  IonSpinner,
} from "@ionic/react";
import { useDispatch } from "react-redux";
import { setPatientsFilter } from "./patientsSlice";
import MonthYearPicker from "../../components/MonthYearPicker";
import { useIntl } from "react-intl";

const Header = (props) => {
  const { patientsFilter, onSearch, loading } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  return (
    <div className="stick_to_top">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0px 12px 0 12px",
        }}
      >
        <MonthYearPicker />
        {loading ? (
          <IonSpinner />
        ) : (
          <IonSelect
            value={patientsFilter}
            onIonChange={(e) => dispatch(setPatientsFilter(e.detail.value))}
            interface="action-sheet"
          >
            <IonSelectOption value="active_and_candidates">
              {intl.formatMessage({
                id: "app.mobile.filters.active_and_candidates",
              })}
            </IonSelectOption>
            <IonSelectOption value="not_active">
              {intl.formatMessage({
                id: "app.mobile.filters.not_active",
              })}
            </IonSelectOption>
            <IonSelectOption value="long_hospitalized">
              {intl.formatMessage({
                id: "app.mobile.filters.long_hospitalized",
              })}
            </IonSelectOption>
          </IonSelect>
        )}
      </div>
      <IonSearchbar
        onIonChange={(e) => onSearch(e.detail.value)}
        placeholder={intl.formatMessage({
          id: "app.mobile.search_by_patient_name",
        })}
      ></IonSearchbar>
    </div>
  );
};

export default Header;
